export default __webpack_public_path__ + "static/media/linkedin.87ae17d5.svg";